import React, { useCallback, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import styled from "styled-components/macro";

import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import Modal from "../../../components/Modal";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer";
import axios from "axios";

const Container = styled.div`
  background-color: #fff;
  min-height: 100vh;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

const ProfileCon = styled.div`
  width: 100%;
  margin-top: 80px;
`;

const Profile = styled.div`
  width: 80%;
  background-color: #f5f5f5;
  margin: 0 auto;
  height: 170px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: center;
  padding: 0px 60px;
  border: 1.5px solid lightgray;
  border-radius: 10px;
`;

const InputCon = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 132px;
  width: 100%;
  background-color: #ffffff;
  margin: 30px 0;
  border-radius: 10px;
  padding: 0px 60px 0px 20px;

  div {
    color: #656565;
  }

  .name {
    margin-bottom: 10px;
  }
`;

const Input = styled.input`
  background-color: #f5f5f5;
  height: 40px;
  border: 1px solid lightgray;
  /* width: 400px; */
  width: 90%;
  height: 31px;
  color: #2a3a4b;
  padding-left: 10px;
`;

const SaveCon = styled.div`
  width: 100%;
  margin-top: 30px;
  div {
    width: 50%;
    background-color: oldlace;
    margin: 0 auto;
    background-color: #73972c;
    height: 44px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
`;

const ChangeName = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [serachparams] = useSearchParams();

  const { me, Routerpath, settingUserInfo } = useSelector(
    (state: RootState) => state.user
  );

  const [name, setName] = useState<any>("");
  const [modal, setModal] = useState<boolean>(false);

  useEffect(() => {
    setName(serachparams.get("name"));
  }, []);

  useEffect(() => {
    dispatch(
      userSlice.actions.Routerpath(
        `/ChangeName?userId=${serachparams.get(
          "userId"
        )}&name=${serachparams.get("name")}&memberId=${serachparams.get(
          "memberId"
        )}`
      )
    );
  }, []);

  const postfunc = useCallback(
    async (type: string) => {
      try {
        if (type === "YES") {
          if (name.includes(" ")) {
            return confirmAlert({
              title: "텍스트에 공백이 있습니다. 공백을 제거해주세요",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          }
          if (!name) {
            return confirmAlert({
              title: "닉네임을 입력해주세요.",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          }

          if (settingUserInfo?.name === name) {
            return confirmAlert({
              title: "이전 닉네임과 동일합니다.",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          }

          let data = {
            memberId: Number(serachparams.get("memberId")),
            userId: serachparams.get("userId"),
            name: name,
          };
          const response = await axios.put(
            `/ifactory/api/member/changename`,
            data
          );
          setModal(false);

          if (response.status === 200) {
            confirmAlert({
              title: "닉네임을 변경하였습니다.",
              buttons: [
                {
                  label: "Yes",
                },
              ],
            });
          }
          navigate("/Setting");
        } else if (type === "NO") {
          setModal(false);
        }
      } catch (error) {
        confirmAlert({
          title: "닉네임 변경에 실패하였습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });

        console.error(error);
      }
    },
    [modal]
  );

  const onChangefunc = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setName(e.target.value);
    },
    [name]
  );
  return (
    <Container>
      <PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
              navigate(-1);
            }}
          />
        </p>
        <p className="pagetit">계정목록</p>
      </PageTop>

      <ProfileCon>
        <Profile>
          <InputCon>
            <div className="name">이름</div>
            <Input value={name} onChange={onChangefunc} />
          </InputCon>
        </Profile>
      </ProfileCon>
      <SaveCon>
        <div onClick={() => setModal(true)}>저장</div>
      </SaveCon>
      {modal && (
        <Modal
          title={"수정하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => postfunc("YES")}
          secondclick={() => postfunc("NO")}
        />
      )}
    </Container>
  );
};

export default ChangeName;
